import React from 'react';
import { useToast } from '../contexts/ToastContext';
import Toast from './Toast';

const ToastContainer: React.FC = () => {
  const { toasts, hideToast } = useToast();

  return (
    <div className="fixed top-20 right-4 z-50 space-y-3">
      {toasts
        .filter(toast => toast && toast.id) // Filter out undefined or invalid toasts
        .map((toast) => (
          <div key={toast.id} className="transform transition-all duration-300 ease-in-out">
            <Toast toast={toast} onClose={() => hideToast(toast.id)} />
          </div>
        ))}
    </div>
  );
};

export default ToastContainer; 